import { TaskServiceModel, TaskServiceSettingsConfigurationModel, TaskServicesGlobalConfigurationModel } from '@/types';
import axios from 'axios';

const TaskServicesConfigurationApiUrl = 'taskServicesConfiguration/';

export const TaskServicesService = {
  async getAllTaskServices(): Promise<TaskServiceModel[]> {
    const response = await axios.get(TaskServicesConfigurationApiUrl);
    return response.data;
  },
  async getTaskServiceConfiguration(serviceName: string): Promise<TaskServiceSettingsConfigurationModel> {
    const response = await axios.get(`${TaskServicesConfigurationApiUrl}${serviceName}`);
    return response.data;
  },
  async updateTaskServiceConfiguration(taskServiceSettingsConfiguration: TaskServiceSettingsConfigurationModel) {
    const response = await axios.put(
      `${TaskServicesConfigurationApiUrl}${taskServiceSettingsConfiguration.taskService.queueName}`,
      taskServiceSettingsConfiguration);
    return response.data;
  },
  async getGlobalConfiguration(): Promise<TaskServicesGlobalConfigurationModel> {
    const response = await axios.get(`${TaskServicesConfigurationApiUrl}globalConfiguration`);
    return response.data;
  },
  async updateGlobalConfiguration(taskServicesGlobalConfiguration: TaskServicesGlobalConfigurationModel) {
    const response = await axios.put(
      `${TaskServicesConfigurationApiUrl}globalConfiguration`, taskServicesGlobalConfiguration);
    return response.data;
  },
  async getAllHosts() {
    const response = await axios.get(`${TaskServicesConfigurationApiUrl}hosts`);
    return response.data;
  }
};